import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

interface ServiceGalleryRaw {
    key: string;
    service: string;
    image: string;
}

export default class ServiceGallery {
    key: string;
    service: string;
    image: string | null;

    constructor(data: ServiceGalleryRaw) {
        this.key = data.key;
        this.service = data.service;
        this.image = data.image;
    }

    public static readonly list = async (
        uuid: string,
        brand: string,
        category: string,
        service: string
    ) =>
        (
            (await axios
                .get(
                    environment.api_url +
                        "/" +
                        brand +
                        "/category/" +
                        category +
                        "/service/" +
                        service +
                        "/gallery/list",
                    {
                        headers: {
                            "User-Token": uuid,
                        },
                    }
                )
                .then((res) => (res.status === 200 ? res.data : undefined))
                .catch(console.error)) as ServiceGalleryRaw[] | undefined
        )?.map((x) => new ServiceGallery(x));

    public static readonly register = async (
        uuid: string,
        brand: string,
        category: string,
        service: string,
        image: string | null
    ) => {
        return axios.post(
            environment.api_url +
                "/" +
                brand +
                "/category/" +
                category +
                "/service/" +
                service +
                "/gallery",
            {
                image,
            },
            {
                headers: {
                    "User-Token": uuid,
                },
            }
        );
    };

    public static readonly update = async (
        uuid: string,
        brand: string,
        category: string,
        service: string,
        key: string,
        image: string
    ): Promise<boolean> => {
        try {
            const res = await axios.put(
                `${environment.api_url}/${brand}/category/${category}/service/${service}/gallery/${key}`,
                { image },
                {
                    headers: {
                        "User-Token": uuid,
                    },
                }
            );
            return res.status === 200;
        } catch (err) {
            console.error("ServiceGallery.update error:", err);
            return false;
        }
    };

    public static readonly unregister = async (
        uuid: string,
        brand: string,
        category: string,
        service: string,
        item: string
    ) => {
        axios.delete(
            environment.api_url +
                "/" +
                brand +
                "/category/" +
                category +
                "/service/" +
                service +
                "/gallery/" +
                item,
            {
                headers: {
                    "User-Token": uuid,
                },
            }
        );
    };
}
